import _ from 'lodash'
import { ActionTypes } from '../constants'
import Card from '../models/card'

const taskWrapper = (attributes) => new Card(attributes)

const processTasks = (action) => {
  const { tasks } = action
  return _.mapValues(
    _.keyBy(tasks, _.property('task.id')), (result) => {
      return _.update(result, 'task', taskWrapper)
    }
  )
}

const tasks = (state = {
  objects: {},
  fetching: false,
  didInvalidate: false,
  updatedOn: null,
  error: null
}, action) => {
  switch (action.type) {
  case ActionTypes.TASKS_REQUEST:
    return { ...state, fetching: true, error: null }

  case ActionTypes.TASKS_RECEIVING_SUCCESS:
    return {
      ...state,
      fetching: false,
      updatedOn: action.updatedOn,
      objects: processTasks(action),
      didInvalidate: false
    }

  case ActionTypes.TASKS_RECEIVING_FAILURE:
    return {
      ...state,
      fetching: false,
      error: action.error,
      didInvalidate: true
    }

  case ActionTypes.TASKS_INVALIDATION:
    return { ...state, didInvalidate: true }

  case ActionTypes.TASK_RATE_SUCCESS:
    return {
      ...state,
      objects: Object.assign({}, state.objects, {
        [action.task.id]: Object.assign(
          {}, state.objects[action.task.id], { rating: action.rating }
        )
      })
    }

  default:
    return state
  }
}

const students = (state = {
  tasks: {},
  rating: { updating: false, error: null },
  participate: { starting: false, error: null },
  finish: { finishing: false, error: null }
}, action) => {
  switch (action.type) {
  case ActionTypes.TASKS_REQUEST:
  case ActionTypes.TASKS_RECEIVING_SUCCESS:
  case ActionTypes.TASKS_RECEIVING_FAILURE:
    return {
      ...state,
      tasks: Object.assign({}, state.tasks, {
        [action.tour]: tasks(state.tasks[action.tour], action)
      })
    }

  case ActionTypes.TASK_RATE_REQUEST:
    return { ...state, rating: { updating: true, error: null } }

  case ActionTypes.TASK_RATE_FAILURE:
    return {
      ...state,
      rating: {
        updating: false,
        error: action.error
      }
    }

  case ActionTypes.TASK_RATE_SUCCESS:
    const { task } = action
    return {
      ...state,
      rating: { updating: false, error: null },
      tasks: Object.assign({}, state.tasks, {
        [task.tour]: tasks(state.tasks[task.tour], action)
      })
    }

  case ActionTypes.TASKS_INVALIDATION:
    return {
      ...state,
      tasks: Object.assign({}, state.tasks, {
        [action.tour]: tasks(state.tasks[action.tour], action)
      })
    }

  case ActionTypes.PARTICIPATE_REQUEST:
  case ActionTypes.RESTART_OLYMPIAD_REQUEST:
    return {
      ...state, participate: {
        ...state.participate, starting: true, error: null
      }
    }

  case ActionTypes.PARTICIPATE_SUCCESS:
  case ActionTypes.RESTART_OLYMPIAD_SUCCESS:
    return {
      ...state, participate: {
        ...state.participate, starting: false
      }
    }

  case ActionTypes.PARTICIPATE_FAILURE:
  case ActionTypes.RESTART_OLYMPIAD_FAILURE:
    return {
      ...state, participate: {
        ...state.participate, starting: false, error: action.error
      }
    }

  case ActionTypes.FINISH_OLYMPIAD_REQUEST:
    return {
      ...state, finish: {
        ...state.participate, finishing: true, error: null
      }
    }

  case ActionTypes.FINISH_OLYMPIAD_SUCCESS:
    return {
      ...state, finish: {
        ...state.participate, finishing: false
      }
    }

  case ActionTypes.FINISH_OLYMPIAD_FAILURE:
    return {
      ...state, finish: {
        ...state.participate, finishing: false, error: action.error
      }
    }

  default:
    return state
  }
}

export default students
